import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BackendService } from '../state-mangement/backend/backend.service';
import { SessionService } from '../state-mangement/session/session.service';
import { SessionQuery } from '../state-mangement/session/session.query';
import { ToastService } from '../services/toast-service';
import { TranslateService } from '@ngx-translate/core';
import { TextKeys } from '../i18n/text-keys';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private backendService: BackendService,
    private sessionQuery: SessionQuery,
    private sessionService: SessionService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 401) {
      return this.handleUnauthorized(error);
    }

    if (
      error.error instanceof ErrorEvent ||
      error.error instanceof ProgressEvent
    ) {
      this.backendService.backendOffline();
      return throwError(() => error);
    }

    if (error.error?.SystemException != null) {
      return this.handleSystemException(error);
    }

    return throwError(() => error);
  }

  private handleUnauthorized(error: HttpErrorResponse): Observable<any> {
    const session = this.sessionQuery.getValue();
    if (!session?.pending && session?.successful) {
      this.sessionService.logout();
      return throwError(() => error);
    }
    return throwError(() => error);
  }

  private handleSystemException(error: HttpErrorResponse): Observable<any> {
    if (error.error.SystemException === false) {
      this.backendService.servicePauseActive();
    } else if (error.error.SystemException === true) {
      const errorMessage = this.translateService.instant(
        TextKeys.error.general
      );
      this.toastService.presentErrorToast({ message: errorMessage });

      if (error.error.message) {
        this.toastService.presentErrorToast({ message: error.error.message });
      }
    }
    return throwError(() => error);
  }
}
